<template>
    <div>
      <BjDrawerForm
        ref="BjDrawerForm"
        :form="form"
        :rules="rules"
        :confirmDis="!hasChecklistFile || !canUpload"
        :wrapper-closable="true"
        :destroy-on-close="true"
        label-width="120px"
        width="500px"
        @handleConfirm="handleConfirm"
      >
        <BjDivider>{{ $t('CustomerFunction.step5') }}</BjDivider>
        <el-col :span="24">
          <UploadFile ref="UploadFileRef" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" accept=".word, .excel, .pdf" multiple concurrent auto-upload limit-hide @handleFileListChange="fileChange">
            <template slot="default">
              <el-button :disabled="!canUpload" size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
            </template>
          </UploadFile>
          <div class="profit-fileRight">
            <template v-if="hasChecklistFile">
              <div v-for="(file, index) in form.checklistFileList" :key="`${file.url}_${index}`" class="file" style="line-height:1.5;font-weight: 500;font-size: 14px;">
                <div class="fileUpload">
                  <div class="flex-align flex-spacebetween" style="color: #3173d0; cursor: pointer;">
                    <div class="flex">
                      <div style="width: 190px;" class="ellipsis">
                        <el-tooltip class="item" effect="dark" :content="file.name" placement="top">
                          <span class="mr20">{{ file.name }}</span>
                        </el-tooltip>
                      </div>
                    </div>
                    <div class="flex-align flex-spacebetween">
                      <el-button size="mini" class="edit-btn" style="font-size: 12px;margin-right:10px" @click="downloadImageUrl(file.url, file.name)">{{ $t('downloadText') }}<i class="el-icon-download el-icon--right"></i></el-button>
                      <el-button :disabled="!canUpload" size="mini" class="delete-btn" style="font-size: 12px;margin-right:10px" @click="delFile(index)">{{ $t('delText') }}<i class="el-icon-delete red el-icon--right"></i></el-button>
                    </div>
                  </div>
                </div>
              </div>
            </template> 
          </div>
        </el-col>
      </BjDrawerForm>
    </div>
  </template>
  <script>
  import { funConfigApi } from '@/api';
  import { downloadImageUrl, normalizeDownloadUrl } from '@/utils';
  import UploadFile from './UploadFile';
  
  const getDefaultForm = () => {
    return {
      id:null,
      checklistFileList: [],
    };
  };
  
  export default {
    components: { UploadFile },
    data() {
      return {
        form: getDefaultForm(),
        canUpload:true,
      };
    },
    computed: {
      hasChecklistFile() {
        return Array.isArray(this.form.checklistFileList) &&
          this.form.checklistFileList.some(file => file && file.name && file.url);
      },
    },
    methods: {
      show(info) {
        const checklistFileList = this.normalizeChecklistFiles(info && info.checklistFileList);
        this.form = Object.assign(getDefaultForm(), info || {}, { checklistFileList });
        this.$refs.BjDrawerForm.show();
        this.$nextTick(() => {
          if (this.$refs.UploadFileRef) {
            this.$refs.UploadFileRef.setFileList(checklistFileList);
          }
        });
      },
      // 统一文件列表结构，仅保留接口需要的 name、url
      normalizeChecklistFiles(files) {
        return (Array.isArray(files) ? files : [])
          .map(file => ({
            name: file && file.name,
            url: normalizeDownloadUrl(file && file.url),
          }))
          .filter(file => file.name && file.url);
      },
      // 多文件上传列表
      fileChange(files) {
        this.form.checklistFileList = this.normalizeChecklistFiles(files);
      },
      // 下载图片
      downloadImageUrl(imageUrl, filename) {
        return downloadImageUrl(imageUrl, filename || 'Checklist File.png');
      },
      // 删除指定文件
      delFile(index) {
        const checklistFileList = this.form.checklistFileList.filter((file, fileIndex) => fileIndex !== index);
        this.form.checklistFileList = checklistFileList;
        if (this.$refs.UploadFileRef) {
          this.$refs.UploadFileRef.setFileList(checklistFileList);
        }
      },
      handleConfirm() {
        if (!this.hasChecklistFile) {
          return this.$message.warning(this.$t('ExcelConfig.upload'));
        }
        const POST_DATA = this.$lodash.clone(this.form);
        delete POST_DATA.checklistFile;
        delete POST_DATA.checklistName;
        funConfigApi.putOnboardingList(POST_DATA).then(res => {
          if (!res.failed) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.form = getDefaultForm();
              if (this.$refs.UploadFileRef) {
                this.$refs.UploadFileRef.setFileList([]);
              }
              this.$refs.BjDrawerForm.hide();
              this.$emit('reFresh');
            }, 500);
          }
        });
      },
    },
  };
  </script>
  <style scoped>
  .el-tag {
    margin: 6px;
  }
  </style>
  
